import React, { Component, PureComponent } from 'react';
import {NavLink, Link} from 'react-router-dom'
import './index.scss'
import Specials from './Specials'
import Catering from './Catering'
import OurStory from './OurStory'
export { Specials as special }
export { Catering as catering }
export { OurStory as about }

export const customOrderAppPaths = ["/menu", "/order"]


class TwoGuysFromItalyGlendale extends Component {
  render() {
    return (
      <div className="twoguysfromitalyglendale">
      </div>
    );
  }
}

export const pages = [
  {path: "/order", label: "Order"},
  {path: "/special", label: "Coupons", component: Specials},
  {path: "/catering", label: "Catering", component: Catering},
  // {path: "/about", label: "Our Story", component: OurStory},
]

export class SiteNav extends PureComponent {
  render() {

    return (
    <nav className="pages-nav">
      <ul>
        {pages.map(({path, label}) => (
          <li><NavLink className="page-link" to={path}>{label}</NavLink></li>
        ))}
      </ul>
    </nav>
  )}
}

export class OrderingHeader extends PureComponent {
  render() {
    return (
      <div className="order-benefits-wrapper">
        <div className="order-benefits">

          <div
            className="text"
             >


            <p>Order Togo & Delivery</p>
          </div>
        </div>
      </div>
    );
  }
}
// logo link: https://d2abh92eaqfsaa.cloudfront.net/image/upload/u7ryxhrj9dapgz8pqmny
export class Header extends PureComponent {
  render() {
    return (
      <div className="landing-page-wrapper">

        <div className="sections-wrapper">
          <section className="section banner">
            <div className="content"
              style={{
                backgroundImage: `url(https://afag.imgix.net/omars-pizza/mural.jpg?w=1400)`,
              }}
              >
                <div className="text">
                  <h1>A Slice of New York.</h1>
                  <div className="button-wrapper">
                    <Link
                      className="order-online-button"
                      to="/order">Order Online
                    </Link>
                  </div>
                </div>

              </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1499778003268-cbafc6d08bab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=650&q=80)`,

              }}
              >
              <div className="text">
                <h2>Menus</h2>
                <Link to="/menu">view menu</Link>
              </div>
            </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://images.unsplash.com/photo-1551978155-63d44a16fe24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=650&q=80)`,

              }}
              >
              <div className="text">
                <h2>Catering</h2>
                <Link to="/catering">view catering</Link>
              </div>
            </div>
          </section>

          <section className="section">
            <div className="content"
              style={{
                backgroundImage: `url(https://s3-media2.fl.yelpcdn.com/bphoto/_M_fSY_gfpArtUj3xEUorA/o.jpg)`,

              }}
              >

              <div className="text">
                <h2>Visit Us</h2>
                <a href="https://www.google.com/maps/place/Omar's+Pizza/@34.1351654,-118.0298097,16z/data=!4m8!1m2!2m1!1somar's+pizza!3m4!1s0x80c2dbddf4c92843:0x30051541cd2b9e9b!8m2!3d34.1299325!4d-118.0295641">33 E Duarte Rd, Arcadia</a>
                {/* <p>Glendale, CA 91206</p> */}
                {/* <small><a href="tel:+18182400020">(818)240-0020</a></small> */}
              </div>
            </div>
          </section>
        </div>



        {/* <div className="order-benefits home">

          <div
            className="text"
             >
           <h1><img style={{width: "125px"}}
             src="https://d2abh92eaqfsaa.cloudfront.net/image/upload/u7ryxhrj9dapgz8pqmny" alt="Two Guys from Italy — Glendale"/></h1>
            <small>405 N Verdugo Rd Glendale, CA</small><br/>
            <small><a href="tel:+18182400020">(818)240-0020</a></small>

          </div>
        </div> */}
      </div>
    );
  }
}

const foodImages = [
  'https://afag.imgix.net/two-guys-from-italy-glendale/meat-balls-pasta.jpg?w=800&auto=compress',
  'https://afag.imgix.net/two-guys-from-italy-glendale/porchiuto.jpg?w=800&auto=compress',
  'https://afag.imgix.net/two-guys-from-italy-glendale/pizza.jpg?w=800&auto=compress',
  'http://www.glendaletwoguysfromitaly.com/img/carousel/home_bg_d.jpg',
  'http://www.glendaletwoguysfromitaly.com/img/carousel/home_bg_e.jpg'
]

export default TwoGuysFromItalyGlendale;
